import { render, staticRenderFns } from "./CarouselPage.vue?vue&type=template&id=5517b998&scoped=true"
import script from "./CarouselPage.vue?vue&type=script&lang=js"
export * from "./CarouselPage.vue?vue&type=script&lang=js"
import style0 from "./CarouselPage.vue?vue&type=style&index=0&id=5517b998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5517b998",
  null
  
)

export default component.exports